import * as colors from '../colors/data'
import fileNameParts from './components'
import { i18n } from '../lang/index'
import { Material } from './materials'

interface SubCategory {
  displayText: string;
  showBack?: boolean;
  types: SubCategoryType[];
}

interface SubCategoryType {
  fileKey: string;
  material?: Material;
  colors: Array<string>;
  typeName?: string;
}

const gehauseSubcategory: SubCategory[] = [
  {
    types: [{
      fileKey: fileNameParts.GEHAUESE_PART,
      colors: colors.ExoGehaeuse
    }],
    displayText: i18n.tc('components.ExoGehaeuse'),
  },
  {
    types: [{
      fileKey: fileNameParts.KRONE_PART,
      colors: colors.Krone

    }],
    displayText: i18n.tc('components.Krone'),
  }
]

const zifferBlattSubCategory: SubCategory[] = [
  {

    displayText: i18n.tc('components.Zifferblatt'),
    types: [
      {
        fileKey: fileNameParts.ZIFFERBLATT_PART,
        colors: colors.Zifferblatt,
        material: Material.FACETED_MATERIAL,
        typeName: i18n.tc('materials.faceted')
      },
      {
        fileKey: fileNameParts.ZIFFERBLATT_PART,
        colors: colors.Zifferblatt,
        material: Material.BRUSHED_MATERIAL,
        typeName: i18n.tc('materials.brushed')
      }

    ]
  },
  {
    types: [{
      colors: colors.SekZeiger,
      fileKey: fileNameParts.SEKZEIGER_PART,
    }],
    displayText: i18n.tc('components.SekZeiger'),
  },
  {
    types: [{
      fileKey: fileNameParts.SEKRING_PART,
      colors: colors.SekRing

    }],
    displayText: i18n.tc('components.SekRing'),
  }
]

const rueckseiteCategory: SubCategory[] = [
  {
    types: [{
      fileKey: fileNameParts.ROTORWABEN_PART,
      colors: colors.RotorWaben,

    }],
    displayText: i18n.tc('components.RotorWaben'),
    showBack: true
  },
  {
    types: [{
      fileKey: fileNameParts.SCHRAUBEN_PART,

      colors: colors.Schrauben,
    }],
    displayText: i18n.tc('components.Schrauben'),
    showBack: true
  },
  {
    types: [{
      fileKey: fileNameParts.WERKHALTERRING_PART,
      colors: colors.Werkhaltering,

    }],
    displayText: i18n.tc('components.Werkhaltering'),
    showBack: true
  }
]
const bandCategory: SubCategory[] = [
  {
    types: [{
      fileKey: fileNameParts.BAND_PART,
      colors: colors.Band

    }],
    displayText: i18n.tc('components.Band'),
  },
  {
    types: [{
      fileKey: fileNameParts.NAHT_PART,
      colors: colors.Naht

    }],
    displayText: i18n.tc('components.Naht'),
  }
]

export { bandCategory, gehauseSubcategory, zifferBlattSubCategory, rueckseiteCategory, SubCategory, SubCategoryType }